import TechnicalSpecifications from './TechnicalSpecifications.vue'

export default TechnicalSpecifications
